// extracted by mini-css-extract-plugin
export default {"blur":"Modal_blur__GSQMh","text":"Modal_text__1VJ4D","card":"Modal_card__o7w1+","img":"Modal_img__lGrB6","submitBtn":"Modal_submitBtn__oyzQH"};